export const TRADEMARK_SERVICE_KEYS = {
  trademarkRegistration: 'trademarkRegistration',
  comprehensiveTrademarkSearch: 'comprehensiveTrademarkSearch',
  statementOfUse: 'statementOfUse',
  trademarkMonitoring: 'trademarkMonitoring',
  officeActionResponse: 'officeActionResponse',
  trademarkRenewal: 'trademarkRenewal',
  requestExtension: 'requestExtension',
  trademarkRevive: 'trademarkRevive',
  logoDesignService: 'logoDesignService',
};
